import React from "react";
import { Link } from "react-router-dom";

const ReportPage = () => {
  const username = localStorage.getItem("username");
  const businessCode = localStorage.getItem("businessCode");
  const businessName = localStorage.getItem("businessName");
  const branchAuthorities = localStorage
    .getItem("branchAuthorities")
    ?.split(",");

  const filteredBranchCodes = branchAuthorities
    .filter((branch) => branch.startsWith(businessCode))
    .map((branch) => branch.split(";")[1]);

  const branchCodes = filteredBranchCodes;
  localStorage.setItem("branchCodes", branchCodes);

  const submenu = [
    {
      title: "Report Cash",
      subtitle: "Laporan kas",
      link: "/report/cash",
    },
    {
      title: "Report Bank",
      subtitle: "Laporan bank",
      link: "/report/bank",
    },
    {
      title: "Report Sales Detail",
      subtitle: "Laporan penjualan detail",
      link: "/report/sales",
    },
    {
      title: "Report Daily Sales",
      subtitle: "Laporan Daily Sales",
      link: "/report/daily",
    },
    {
      title: "Report Sales by Unit",
      subtitle: "Laporan Penjualan Unit",
      link: "/report/customerdetail",
    },
    {
      title: "Report Profit and Loss",
      subtitle: "Laporan car profit loss unit",
      link: "/report/pl",
    },
    {
      title: "Report Finance",
      subtitle: "Laporan keuangan",
      link: "/report/finance",
    },
  ];

  return (
    <div>
      <div className="min-h-screen bg-gray-100 pt-20 px-5">
        <div className="max-w-7xl mx-auto bg-white p-8 rounded-lg shadow-lg">
          <h1 className="welcome-message text-2xl font-semibold text-gray-800 mb-6">
            Welcome, {username}!
          </h1>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {submenu.map((item, index) => (
              <div key={index} className="business-card p-4 rounded-lg bg-blue-100 shadow-md hover:shadow-lg transition-shadow duration-200">
                <ul className="grid grid-cols-1 auto-rows-fr">
                  <li>
                    <Link to={item.link}>
                      <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                        <div className="font-semibold">{item.title}</div>
                        <span className="text-sm text-gray-500 dark:text-gray-400">
                          {item.subtitle}
                        </span>
                      </a>
                    </Link>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
        <style jsx>{`
          .min-h-screen {
            min-height: 100vh;
          }
          .welcome-message {
            color: #333;
          }
          .business-card {
            transition: transform 0.2s;
          }
          .business-card:hover {
            transform: translateY(-2px);
          }
          .business-code {
            font-size: 18px;
            color: #1d4ed8; /* Tailwind blue-600 */
          }
        `}</style>
      </div>
    </div>
  );
};

export default ReportPage;